import { useState } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormGroup, Modal } from 'react-bootstrap';
import { FileRejection, DropEvent } from 'react-dropzone';
import FileUpload from '@nkr/components/file-upload';

interface IProps {
    show: boolean,
    fullName: string,
    onSubmit: (file: File) => void,
    onCancel: () => void
}

const UploadLabResults = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const [filesValid, setFilesValid] = useState(true);
    const [dirty, setDirty] = useState(false);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = (name: string) => {
        setFiles([]);
    };

    const handleSubmit = () => {
        let filesValid = files.length > 0;

        setFilesValid(filesValid);
        setDirty(true);

        if (filesValid) {
            props.onSubmit(files[0]);
        }
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Upload Lab Results</Modal.Header>
            <Modal.Body>
                {!filesValid && (
                    <Alert bsStyle='danger'>The items are in red are required to submit...</Alert>
                )}

                <Alert bsStyle='info' bsSize='sm' style={{ marginBottom: 20, textAlign: 'center' }}>
                    For donor <strong>{props.fullName}</strong>, please upload the lab results file...
                </Alert>

                <Form horizontal>
                    <FormGroup validationState={dirty && filesValid == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Upload PDF File:</Col>
                        <Col xs={12} lg={8}>
                            <FileUpload
                                label={'Click to select the PDF...'}
                                files={files}
                                singleUploadOnly={true}
                                onFileDropped={handleFileDropped}
                                onRemoveFile={handleRemoveFile} />
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Upload and Notify Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadLabResults;